

<script>
import store from '../store/index.js';
import {isAutohomeApp, inView, scrollTo} from '../../../../common/util';
import titleCoupon from '../../assets/title-coupon.png';
import city from '../form/city';
import labelInput from '../form/labelInput';
import statement from "../form/statement";
import success from '../form/success';
import sidebar from '../form/spec/sidebar';
import {alertMessage} from '@/lib/ui';

export default {
    data(){
        return {
            load: !window.__PRERENDER_INJECTED,
            mobileConf: {
                id: 'mobile',
                label: '手机号：',
                maxLength: 11,
                placeholder: '请输入手机号',
                errMsg: '请输入正确格式的手机号',
                eye: false,
                tips: false,
                verify: {
                    change(val) {
                        return /^1\d{10}$/.test(val);
                    },
                    input(val) {
                        return /^\d{1,11}$/.test(val);
                    }
                }
            },
            nameConf: {
                id: 'name',
                label: '姓名：',
                maxLength: 10,
                placeholder: '如王先生、李女士',
                errMsg: '请输入您的姓名',
                verify: {
                    change(val) {
                        return val.trim() !== '';
                    }
                }
            },
            isShowFixed: false,
            isSubmitImg: false,
            status: false,
            isShowCouponBlock: false,
            isClickCouponBlock: false,
            isCloseCouponBlock: false
        }
    },
    components: {
        city,
        labelInput,
        success,
        sidebar
    },
    mounted() {
      window.addEventListener('scroll', () => {
        if(inView(document.querySelector('.js-coupon-block'))) {
          if (this.isShowCouponBlock) {
            return;
          }
          this.isShowCouponBlock = true;
          this.$clickMonitor.send({
            buttonId: 'show-coupon-block',
            ...store.getClickMonitorParams()
          });
        }
      });
    },
    computed: {
        titleCoupon() {
          return titleCoupon;
        },
        mobile: {
            get() {
                return store.form.mobile;
            },
            set(val) {
                store.form.mobile = val;
            }
        },
        name: {
            get() {
                return store.form.name;
            },
            set(val) {
                store.form.name = val;
            }
        },
        seriesImg: {
          get() {
                return store.seriesImg;
            },
        },
        seriesName () {
          return store.seriesName;
        },
        discountText: {
          get() {
              var discountText = ''
                switch (store.form.series.id + '') {
                  case '4410':
                    discountText = '2年0利息'
                    break;
                  case '5048':
                    discountText = '2年0利息'
                    break;
                  case '2771':
                    discountText = '3年0利息'
                    break;
                  case '4150':
                    discountText = '2年0利息'
                    break;
                  case '5566':
                    discountText = '即将上市'
                    break;
                  case '4410':
                    discountText = '2年0利息'
                    break;
                  default:
                    break;
                }
                return discountText;
            },
        },
        spec() {
            return store.form.spec;
        },
        city() {
            return store.form.position;
        },
        isShowCoupon() {
          return store.isShowCoupon;
        },
        couponValue() {
            return store.couponValue;
        },
        couponUseTime() {
            return store.couponUseTime;

        }
    },  
    methods: {
      showFixed() {
        this.isShowFixed = true;
        if (this.isClickCouponBlock) {
          return;
        }
        this.isClickCouponBlock = true;
        this.$clickMonitor.send({
          buttonId: 'click-coupon-block',
          ...store.getClickMonitorParams()
        });
      },
      closeFixed() {
        this.isShowFixed = false;
        if (this.isCloseCouponBlock) {
          return;
        }
        this.isCloseCouponBlock = true;
        this.$clickMonitor.send({
          buttonId: 'close-coupon-block',
          ...store.getClickMonitorParams()
        });
      },
      check() {
          const mobileError = this.$refs.mobile.checkChange();
          const nameError = this.$refs.name.checkChange();
          // const dealerError = this.$refs.dealer.checkChange();
          return mobileError || nameError;
      },
      async submit() {
          if (this.isSubmitImg) {
            return;
          }
          this.isSubmitImg = true;
          const isError = this.check();
          if (isError) {
              return;
          }
          let alert = alertMessage('查询信息提交中…');
          this.$clickMonitor.send({
            buttonId: `chuxing-button-click`,
            ...store.getClickMonitorParams()
          });
          const result = await store.submit('chuxing-button-click');
          alert.style.display = 'none';
          this.isSubmitImg = false;
          if (!result.status) {
              alertMessage(result.msg);
              return;
          }
          this.isShowFixed = false;
          this.$refs.success1.show();
      },
      sidebarHandler() {
          this.status = true;
      }
    },
}
</script>
<template>
  <div class="wrap" v-show="isShowCoupon">
    <div class="coupon-block js-coupon-block">
      <img :src="titleCoupon" class="coupon-block-title"/>
      <div class="coupon-block-coupon" @click="showFixed()">
        <div class="coupon-block-price"><span class="coupon-block-price-small">¥</span>{{couponValue}}</div>
        <div class="coupon-block-text">之家出行到店打车券</div>
      </div>
      <div class="explain-block">
        <div class="explain-title">使用说明</div>
        <div class="explain-item">1、最高单程可抵扣{{couponValue}}元</div>
        <div class="explain-item">2、此权益领取后{{couponUseTime}}天有效</div>
      </div>
    </div>
    <div class="fixed-block" v-show="isShowFixed">
      <div class="fixed-content">
        <img src="../../assets/coupon-fixed-title.png" class="fixed-content-top-img" />
        <img src="../../assets/coupon-fixed-close.png" alt="" class="fixed-content-close" @click="closeFixed()">
        <div class="fixed-content-title">询价成功立享{{couponValue}}元</div>
        <div class="fixed-content-sub-title">之家出行到店打车券</div>
        <div class="fixed-car-info-block">
          <img :src="seriesImg" alt="" class="car-img">
          <div class="car-name">{{seriesName}}</div>
          <div class="spce-name-block" @click="sidebarHandler()">
            <span class="spce-name">{{spec.name}}</span>
            <img src="data:image/png;base64,/9j/4AAQSkZJRgABAQAASABIAAD/4QBMRXhpZgAATU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAACqADAAQAAAABAAAAEAAAAAD/7QA4UGhvdG9zaG9wIDMuMAA4QklNBAQAAAAAAAA4QklNBCUAAAAAABDUHYzZjwCyBOmACZjs+EJ+/8AAEQgAEAAKAwEiAAIRAQMRAf/EAB8AAAEFAQEBAQEBAAAAAAAAAAABAgMEBQYHCAkKC//EALUQAAIBAwMCBAMFBQQEAAABfQECAwAEEQUSITFBBhNRYQcicRQygZGhCCNCscEVUtHwJDNicoIJChYXGBkaJSYnKCkqNDU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6g4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2drh4uPk5ebn6Onq8fLz9PX29/j5+v/EAB8BAAMBAQEBAQEBAQEAAAAAAAABAgMEBQYHCAkKC//EALURAAIBAgQEAwQHBQQEAAECdwABAgMRBAUhMQYSQVEHYXETIjKBCBRCkaGxwQkjM1LwFWJy0QoWJDThJfEXGBkaJicoKSo1Njc4OTpDREVGR0hJSlNUVVZXWFlaY2RlZmdoaWpzdHV2d3h5eoKDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uLj5OXm5+jp6vLz9PX29/j5+v/bAEMAAQEBAQEBAgEBAgMCAgIDBAMDAwMEBQQEBAQEBQYFBQUFBQUGBgYGBgYGBgcHBwcHBwgICAgICQkJCQkJCQkJCf/bAEMBAQEBAgICBAICBAkGBQYJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCf/dAAQAAf/aAAwDAQACEQMRAD8A/u+uG1HwjcveAvdaVKxZ05eS2LHJZe7Req9U7fLwOygvLW6gS5tpFkjkUMjKQQykZBB7giuOupL/AMW3Emm2hktdMjYpNOPledlOCkfcJnhn79F45rr7Wxs7G1jsrOJYoYVCIigAKqjAAHoBxQB//9k=" alt="" class="right-arrow">
            </div>
          <div class="car-discount">{{discountText}}</div>
        </div>
        <div class="input-block">
          <div class="input-item">
            <div class="label-select">
                <em>购车城市：</em>
                <div class="value" :class="city.cityName ? '': 'placeholder'">{{city.cityName || '如北京'}}</div>
            </div>
          </div>
          <div class="input-item">
            <label-input ref="name" :params="nameConf" v-model="name"></label-input>
          </div>
          <div class="input-item">
            <label-input ref="mobile" :params="mobileConf" v-model="mobile"></label-input>
          </div>
        </div>
        <div class="submit-button" @click="submit()">
          <p class="submit-button-text">免费获取底价</p>
          <p class="submit-button-sub-text">送{{couponValue}}元打车到店券</p>
        </div>
        <div class="explain">提交后即视为同意 <a href="https://dealer.m.autohome.com.cn/dealer/agreement.html">《个人信息保护声明》</a></div>
      </div>
    </div>
    <sidebar :status="status" @update:status="status = $event"></sidebar>
    <statement></statement>
    <success ref="success1" v-if="load"></success>
  </div>
</template>
<style lang="stylus" scoped>
  .coupon-block {
    position relative;
    width:18.4rem;
    height:10.99rem;
    background:rgba(255,138,93,0.18);
    border-radius:0.53rem;
    border:0.05rem solid rgba(251,173,99,0.38);
    margin: auto;
    margin-top: 2.2rem;
    .coupon-block-title {
      width 10.67rem;
      position absolute;
      top: -17%;
      left 50%;
      transform translateX(-50%);
    }
    .coupon-block-coupon {
      height 5.87rem;
      width 17.33rem;
      background: url('../../assets/coupon-1.png');
      background-size: 100% 100%;
      margin: auto;
      margin-top: 1.76rem;
      position relative;
      .coupon-block-price {
        color #7F0100;
        font-size:1.6rem;
        font-weight 700;
        position absolute;
        top: 1rem;
        left: 1.5rem;
        .coupon-block-price-small {
          font-size:0.75rem;
          font-weight 400;
        }
      }
      .coupon-block-text {
        color #7F0100;
        font-size:0.64rem;
        padding 0.05rem 0.48rem;
        border-radius:0.56rem;
        border:0.05rem solid rgba(151,27,25,1);
        position absolute;
        bottom 1.5rem;
        left 1.5rem;
      }
    }
    .explain-block {
      color #FFB2B2;
      font-size:0.53rem;
      padding-left .6rem;
      .explain-title {
        font-weight 600;
        padding-bottom .3rem;
      }
      .explain-item {

      }
    }
  }
  .fixed-block {
    position fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 11;
    background:rgba(0,0,0,0.63);
    .fixed-content{
      height 23.7rem;
      width 18.4rem;
      position absolute;
      top: 50%;
      left 50%;
      transform translate(-50%, -50%);
      background: url('../../assets/coupon-fixed-content.png');
      background-size: 100% 100%;
      .fixed-content-top-img {
        width 16rem;
        position absolute;
        top: -10rem;
        left 1.2rem;
      }
      .fixed-content-close {
        width 1.39rem;
        position absolute;
        bottom -2rem;
        left 50%;
        transform translateX(-50%);
      }
      .fixed-content-title {
        font-size 1.55rem;
        color #7F0100;
        font-weight:600;
        text-align center;
        margin-top 1rem;
      }
      .fixed-content-sub-title {
        font-size:1.07rem;
        color #7F0100;
        text-align center;
      }
      .fixed-car-info-block {
        padding-top 1.2rem;
        position relative;
        .car-img {
          height 4.5rem;
          margin-top -.7rem;
          position absolute;
          left 1.44rem;
        }
        .car-name {
          width 8.75rem;
          overflow hidden;
          color #333333;
          font-size .85rem;
          font-weight 600;
          position absolute;
          left 8rem;
        }
        .spce-name-block {
          width 9rem;
          height 1.07rem;
          line-height 1.07rem;
          overflow hidden;
          font-size:0.64rem;
          color #666666;
          position absolute;
          left 8rem;
          top 2.6rem;
          .spce-name {
            width 7.63rem;
            height 1.07rem;
            line-height 1.07rem;
            overflow hidden;
            font-size:0.64rem;
            color #666666;
          }
          .right-arrow {
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-60%);
          }
        }
        .car-discount {
          width 7.63rem;
          height 1.07rem;
          line-height 1.07rem;
          overflow hidden;
          font-size:0.64rem;
          color #666666;
          position absolute;
          left 8rem;
          top 3.6rem;
        }
      }
      .input-block {
        margin-top 3.3rem;
        .input-item {
          padding 0 1.44rem;
        }
      }
      .submit-button {
        width:14.67rem;
        height:3.04rem;
        background:linear-gradient(144deg,rgba(250,217,97,1) 0%,rgba(247,107,28,1) 100%);
        border-radius:1.52rem;
        margin .96rem auto .3rem;
        text-align center;
        .submit-button-text {
          font-size:0.85rem;
          font-weight 600;
          color #fff;
          padding-top .48rem;
        }
        .submit-button-sub-text {
          font-size:0.53rem;
          font-weight 600;
          color #fff;
        }
      }
      .explain {
        font-size:0.53rem;
        color #999999;
        text-align center;
      }
    }
  }
  .label-select
    position relative
    border-bottom 0.053rem solid #ebebeb
    em
        position absolute
        top 0
        bottom 0
        left 0
        margin auto
        height 1rem
        line-height 1rem
        font-size 0.85rem
        font-style normal
        color #666
    .value 
        padding 0.74rem 1rem 0.74rem 4.5rem
        width 100%
        height 2.48rem
        line-height 1rem
        border 0
        box-shadow none
        box-sizing border-box
        font-size 0.85rem
        color #333
        outline 0
</style>